import React from "react";
import Box from "@mui/material/Box";
import Welcome from "../../components/Dashboard/eCommerce/Welcome";
import TotalSales from "../../components/Dashboard/eCommerce/TotalSales";
import TotalOrders from "../../components/Dashboard/eCommerce/TotalOrders";
import TotalCustomers from "../../components/Dashboard/eCommerce/TotalCustomers";
import TotalRevenue from "../../components/Dashboard/eCommerce/TotalRevenue";
import TotalBrands from "../../components/Dashboard/eCommerce/TotalBrands";
import SalesByLocations from "../../components/Dashboard/eCommerce/SalesByLocations";
import Grid from "@mui/material/Grid2";
import TopSellingProducts from "../../components/Dashboard/eCommerce/TopSellingProducts";
import RecentOrders from "../../components/Dashboard/eCommerce/RecentOrders";
import OrderSummary from "../../components/Dashboard/eCommerce/OrderSummary";
import { useEffect } from "react";
import TotalUsersByType from "../../components/Dashboard/eCommerce/TotalUsersByType";
import axios from "axios";
import { API_ENDPOINTS } from "../../config/api";
import TotalEnquires from "../../components/Dashboard/eCommerce/TotalEnquires";
import TotalRegions from "../../components/Dashboard/eCommerce/TotalRegions";
import UsersByRegions from "../../components/Dashboard/eCommerce/UsersByRegions";
import ProductsCount from "../../components/Dashboard/eCommerce/ProductsCount";
import TopProductTypes from "../../components/Dashboard/eCommerce/TopProductTypes";

const Ecommerce = () => {
  const [dashboardData, setDashboardData] = React.useState({});

  // console.log("dashboardData", dashboardData);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.DASHBOARD);
        setDashboardData(response.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchDashboardData();
  }, []);

  return (
    <Box sx={{ my: 2 }} className="admin-dashboard">
      <Grid
        className="dashboard-full-width-card"
        container
        spacing={2}
        justifyContent="space-between"
      >
        <Grid className="dashboard-left-card" size={{ xs: 12, md: 8 }}>
          <Box className="left-block light-block" sx={{ mb: 2 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TotalCustomers data={dashboardData.usersCount} />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TotalEnquires data={dashboardData.enquiriesCount} />
              </Grid>
            </Grid>
          </Box>

          <Box className="left-block" sx={{ mb: 2 }}>
            <TotalUsersByType />
          </Box>

          <Box className="left-block" sx={{ mb: 2 }}>
            <UsersByRegions data={dashboardData.regionUsersCounts} />
          </Box>

          <Box className="left-block" sx={{ mb: 2 }}>
            <TotalRevenue />
          </Box>

          <Box className="left-block" sx={{ mb: 2 }}>
            <RecentOrders data={dashboardData.recentorders} />
          </Box>
        </Grid>

        <Grid className="dashboard-right-card" size={{ xs: 12, md: 3.8 }}>
        <Box className="right-block" sx={{ mb: 2 }}> 
            <ProductsCount data={dashboardData.productsCount} />
          </Box>
          <Box className="right-block" sx={{ mb: 2 }}> 
            <OrderSummary
              recentorders={dashboardData.recentorders}
              sx={{ mb: 3 }}
            />
          </Box>

          <Box className="right-block" sx={{ mb: 2 }}>
            <TopProductTypes data={dashboardData.topProductsList} />
          </Box>

         
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}></Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={{ my: 1, "& .MuiGrid-item": { height: "100%" } }}
      >
        <Grid size={{ xs: 12, md: 12, height: "100%" }}></Grid>
      </Grid>

      <Grid size={{ xs: 12, md: 4, height: "100%" }}>
        <Grid container sx={{ "& .MuiGrid-item": { height: "100%" } }}></Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}></Grid>

        <Grid size={{ xs: 12, md: 6 }}></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 5 }}></Grid>
        <Grid size={{ xs: 12, md: 7 }}></Grid>
      </Grid>
    </Box>
  );
};

export default Ecommerce;
